
export default {
    path: "/sessoes",
    name: "Sessions",
    component: () => import("@/presentation/views/Sessions/Sessions.vue"),
    redirect: { name: "SessionsList" },
    meta: { requiresAuth: true, allowPermission: 'locations:list' },
    list: {
        path: "lista",
        name: "SessionsList",
        component: () =>
            import("@/presentation/views/Sessions/SessionsList/SessionsList.vue"),
    },
    detail: {
        path: "detalhes/:id",
        name: "SessionDetail",
        component: () =>
            import("@/presentation/views/Sessions/SessionDetail/SessionDetail.vue"),
        redirect: { name: "SessionDetailInfo" },
        info: {
            path: "informacoes",
            name: "SessionDetailInfo",
            component: () =>
                import(
                    "@/presentation/views/Sessions/SessionDetail/SessionDetailInfo/SessionDetailInfo.vue"
                ),
        },
        activity_log: {
            path: "registro-de-atividades",
            name: "SessionDetailActivityLog",
            component: () =>
                import(
                    "@/presentation/views/Sessions/SessionDetail/SessionDetailActivityLog/SessionDetailActivityLog.vue"
                ),
        },
    },
} as const